<template>
  <main :class="[ns.b(), ns.is('fluid', fluid)]" data-test-name="main">
    <slot />
  </main>
</template>
<script lang="ts" setup>
import { useNamespace } from '@bigin/hooks'

defineOptions({
  name: 'BMain',
})

defineProps({
  fluid: Boolean,
})

const ns = useNamespace('main')
</script>
